import type { RailwayBucketSummary } from '@cli-types/next-adapter/railway.js'
import { isNonEmptyString } from '@cli-utils/shared.js'

export function parseBucket(value: unknown): RailwayBucketSummary | undefined {
  if (!value || typeof value !== 'object') return undefined
  const bucket = value as Record<string, unknown>
  return isNonEmptyString(bucket.id) && isNonEmptyString(bucket.name)
    ? { id: bucket.id, name: bucket.name }
    : undefined
}
